import React, { Component } from 'react'
import { graphql } from 'gatsby'
import '../../static/scripts/vendors/lodash.custom.min.js'
import Helmet from '../components/helmet.component'
import Layout from '../components/layout'
import BlockComponent from '../components/block.component'
import {
  isBrowser,
  getUrlParameter,
  getCountryCodeAndLanguage,
  getLoginUrl,
  removeFromStorage,
  replaceImageStyle,
  setHeaderFooterFromCookie,
  setHeaderFooterOnCountryLang
} from '../utils/common.js'
import SignupOverlayNotification from "../components/signupoverlay-notification.component"
import WubotComponent from '../components/wubot.component.js'
import FooterComponent from '../components/footer.component.js'
import { convertCountryLangFormat } from '../utils/countryLangFromUrl.js'

export default class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wuUserLoginStaus: false,
      showOverlayNotification: false
    }
  }
  componentDidMount() {
    this.setLoggedInUserNameHeader();
    this.handleOverlayNotification();
    this.setClickEventOnLogoutLink();
    if ( this.props.pageContext.isGlobal ) {
      setHeaderFooterFromCookie (this.headerContentCookie, this.footerContentCookie);
    }
  }

  terminateSessionService = () => {
    const cookieStore =  window.sessionStorage.cookiestore;
    const codeObjForBashPath = getCountryCodeAndLanguage();
    const {countryCode, langCode} = codeObjForBashPath;
    const getOrigin = window.location.origin;
    const url = `${getOrigin}/wuconnect/rest/api/v1.0/TerminateSession?timestamp=${new Date().getTime()}`
    const bashPath = `/${countryCode}/${langCode}`
    const getTerminateSessionRequestBody = {
      "security": {
        "session": {
          "id": JSON.parse(cookieStore)["SessionId"]
        }
      },
      "bashPath": bashPath
    };
    let xhttp;
    xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = () => {
      if (
        xhttp.readyState === 4 && xhttp.status === 200
      ) {
        console.log('Session has been terminated successfully!!');
        removeFromStorage();
        window.location.href = getLoginUrl();
      }
    };
    xhttp.open("POST", url, true);
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.setRequestHeader("Accept", "application/json");
    xhttp.send(JSON.stringify(getTerminateSessionRequestBody));
  }

  logoutHandler = (event) => {
    try {
      this.terminateSessionService();
    } catch (error) {
      console.log(error);
      removeFromStorage();
      window.location.href = getLoginUrl();
    }
  }

  setClickEventOnLogoutLink() {
    const item = document.getElementById("user-logout-link");
    const item2 = document.getElementById("wu-mobile-logout-button");
    item && item.addEventListener("click", this.logoutHandler);
    item2 && item2.addEventListener("click", this.logoutHandler);
  }

  setLoggedInUserNameHeader() {
    let isEmailVerificationRequired = JSON.parse(window.sessionStorage.getItem('C1124'));
    if (window.sessionStorage.AccountNumber && !isEmailVerificationRequired) {
      this.setState({
        wuUserLoginStaus: true
      }, function () {
        if (this.state.wuUserLoginStaus && window.sessionStorage.FirstName) {
          let firstname = window.sessionStorage.FirstName;
          let lastname = window.sessionStorage.LastName;
          if (firstname) {
            let fullname = `${firstname} ${lastname ? lastname : ''}`
            fullname = fullname.toLowerCase().replace(/\b[a-z]/g, function (letter) {
              return letter.toUpperCase();
            });
            if (window.matchMedia("(min-width: 992px) and (max-width: 1145px)").matches) {
              if (fullname.length > 10) fullname = fullname.substring(0, 10) + '...';
            } else if (window.matchMedia("(min-width: 1145px").matches) {
              if (fullname.length > 20) fullname = fullname.substring(0, 20) + '...';
            }
            const loggedInSection = document.querySelector("#loggedInSection");
            const mobileLoggedInSection = document.querySelector("#mobileLoggedInSection"); 
            const mobileLoginSection = document.querySelector("[data-mobile-menu-content] .nav-dropdown div.pad-xs-horz");
            const navItemLink = document.querySelector(`.wu-header__logo-container .nav-item__link`);
            const navItem = document.querySelectorAll(`a[data-href]`);
            for(let item=0;item<navItem.length;item++) {
              const element = navItem[item];
              let dataHrefAttributeVal = element.getAttribute('data-href');
              element.setAttribute('href', dataHrefAttributeVal);
            }
            // if(mobileLoggedInSection){
              loggedInSection && loggedInSection.classList.add('d-M-flex');
              mobileLoggedInSection.className = mobileLoggedInSection.className.replace('d-none','d-none d-flex');
              document.querySelector("#mobileLogInRegisterSection").classList.remove('d-flex')
              document.querySelector("#mobileLogInRegisterSection").classList.add('d-none')
              // document.querySelector("#loggedInSection .text-action-light-200").innerHTML = fullname;
              // document.querySelector("#mobileLoggedInSection .text-action-light-200").innerHTML = fullname;
              document.querySelector('.font-body-reg.white-space-nowrap.text-granite-300.text-center.mar-xs-tp').innerHTML = fullname
              let hrefLogo = navItemLink && navItemLink.getAttribute(`href`);
              if(hrefLogo) {
                hrefLogo = hrefLogo.replace(`home.html`,`web/send-money/start`);
                navItemLink.setAttribute(`href`,hrefLogo);
              }
            // }
            var signUpNavItem = document.querySelectorAll("#sign-up-nav-item"),
              loginNavItem = document.querySelectorAll("#login-nav-item"),
              wuUserIconNavItem = document.querySelectorAll("#wu-user-icon-nav-item"),
              userLoggedInNavItem = document.querySelectorAll("#user-logged-in-nav-item")

            Array.from(signUpNavItem).forEach((e) => {
              e.className = e.className.replace('d-L-block', 'd-none')
            })
            Array.from(loginNavItem).forEach((e) => {
              e.className = e.className.replace('d-L-block', 'd-none')
            })
            Array.from(wuUserIconNavItem).forEach((e) => {
              e.className = e.className.replace('d-none', 'd-none d-L-block')
            })
            Array.from(userLoggedInNavItem).forEach((e) => {
              e.className = e.className.replace('d-none', 'd-none d-L-block')
            })

            document.querySelector('.wu-user-loggedin-section.pt-0.pb-0.wu-logged-in-section__text.text-granite-300').innerHTML = fullname
            // mobileLoginSection.className = mobileLoginSection.className.replace('d-flex','d-none');
          }
        }
      });
    }
  }

  handleOverlayNotification() {
    if (sessionStorage.getItem('loggedInByOverlay') === 'true') {
      window.history.scrollRestoration = 'manual';
      for (const item in sessionStorage) {
        /^@@scroll/.test(item) && sessionStorage.removeItem(item);
      }
      this.setState({ showOverlayNotification: true });
    }
  }

  getReplacedCurrencyCode(seoData,senderCurrency,receiverCurrency) {
    return seoData && seoData.replace(/{senderCurrencyCode}/gi, senderCurrency)
                             .replace(/{receiverCurrencyCode}/gi, receiverCurrency)
  }

  getReplacedCurrencyName(seoData,senderCurrencyName,receiverCurrencyName) {
    return seoData && seoData.replace(/{senderCurrencyName}/gi, senderCurrencyName)
                             .replace(/{receiverCurrencyName}/gi, receiverCurrencyName)
  }

  getDynamicSeoData(title,isSlug){
    return title.split("##").length >1 && isSlug ? title.split("##")[1]: title.split("##")[0];
  }
  getAppBannerData(countryThemeSetting, language){
    if(language == "en"){
      return countryThemeSetting && countryThemeSetting.countryThemeSettings && countryThemeSetting.countryThemeSettings.appBanner;
    } else{
      let getLanguageNode = countryThemeSetting && countryThemeSetting.languageCountryThemeSetting && countryThemeSetting.languageCountryThemeSetting.languageCountryThemeSettings &&
                            countryThemeSetting.languageCountryThemeSetting.languageCountryThemeSettings.find(o => o.language === language)
      return getLanguageNode && getLanguageNode['appBanner'];
    }
  }
 
  render() {
    const { pageContext, data : { page , countryThemeSetting } } = this.props
    const  {
      pageContent,
      blocks,
      seoMetaData,
      slug,
      headerFooterContent,
      headerContent,
      footerContent,
      switchContent,
      criticalCss,
      mainCssContent,
      isCurrencyConverter,
      isGlobal,
      language,
      country
    } = pageContext
    const appBanner =  this.getAppBannerData(countryThemeSetting, language)
    let { seo } = page
    if (isBrowser() && isGlobal) {
     const codeObjForBashPath = getCountryCodeAndLanguage();
     const countryLang = convertCountryLangFormat(`${codeObjForBashPath.countryCode}${codeObjForBashPath.langCode}`);
     [this.headerContentCookie, this.footerContentCookie ] = setHeaderFooterOnCountryLang(headerFooterContent, countryLang);
    }
    const content = isCurrencyConverter && replaceImageStyle(pageContent);
    let isSlug = /\/currency-converter\/.+\.html$/.test(slug)
    if (seoMetaData) {
      let pageTitle = this.getDynamicSeoData(page["seo"]["title"], isSlug)
      let pageDesc = this.getDynamicSeoData(page["seo"]["metaDesc"], isSlug)
      if (isBrowser()) {
        let sendAmount = getUrlParameter("sendAmount")
        let title = sendAmount ? `${sendAmount} ${seoMetaData.senderCurrency}` : seoMetaData.senderCurrency
        pageTitle =
          pageTitle &&
          this.getReplacedCurrencyCode(
            pageTitle,
            title,
            seoMetaData.receiverCurrency
          )
        pageDesc =
          pageDesc &&
          this.getReplacedCurrencyCode(
            pageDesc,
            title,
            seoMetaData.receiverCurrency
          ) 
        pageDesc = this.getReplacedCurrencyName(pageDesc,seoMetaData.senderCurrencyName,seoMetaData.receiverCurrencyName)
        pageTitle = this.getReplacedCurrencyName(pageTitle,seoMetaData.senderCurrencyName,seoMetaData.receiverCurrencyName) // Showing Currency Name on Page Title 
        page["seo"]["title"] = pageTitle
        page["seo"]["metaDesc"] = pageDesc
      }
    } else {
      page["seo"]["title"] = this.getDynamicSeoData(page["seo"]["title"], isSlug)
      page["seo"]["metaDesc"] = this.getDynamicSeoData(page["seo"]["metaDesc"], isSlug)
    }
    page["seo"]["opengraphTitle"] = page["seo"]["title"]
    page["seo"]["opengraphDescription"] = page["seo"]["metaDesc"]
    let headerContentText = replaceImageStyle(headerContent)
    const isHeadless = (page.disable_Header_And_Footer.disableHeaderAndFooter === 'Yes');
    if (isBrowser()) {
      sessionStorage.setItem('switches', switchContent)
    }
    return (
      <>
        <Helmet pageContext={pageContext} seo={ seo } 
                isEvergageEnabled={isSlug ? 'Yes' : page.evergage_Enabled_Page.evergageEnabledPage }
                isWubotEnabled={ page.Wubot_Enabled_Page.wubotEnabledPage }
         />
        <Layout pageContext={pageContext} appBanner = {appBanner} language={language}>
           {isGlobal && <div className="entry-content" ></div>}
          {!isGlobal && !isHeadless && <div className="entry-content" dangerouslySetInnerHTML={{ __html: headerContentText }} />}
          {page.Wubot_Enabled_Page.wubotEnabledPage === 'Yes' && <WubotComponent />}
          {this.state.showOverlayNotification && <SignupOverlayNotification />}
          {/* <div className="entry-content" dangerouslySetInnerHTML={{ __html: content }} /> */}
          { 
            isCurrencyConverter ?
              <div className="entry-content" dangerouslySetInnerHTML={{ __html: content }} /> 
              :
              blocks.map((bl, index) => {
                // if (
                //   [0, 1].indexOf(bl.order) === -1
                // ) {
                //   const LazyBlockComponent = loadable(() => import('../components/block.component'))

                //   return (
                //     <LazyBlockComponent
                //       index={index}
                //       content={replaceImageStyle(bl.dynamicContent)}>
                //     </LazyBlockComponent>
                //   )
                // } else {
                  return (
                    <BlockComponent
											index={index}
                      content={replaceImageStyle(bl.dynamicContent)}>
                    </BlockComponent>
                  )
                // }
              })
          }
          {!isHeadless && <FooterComponent
                                content = { footerContent } /> }
        </Layout>
      </>
    )
  }
}

export const query = graphql`
  query page($id: String!, $countryName: String) {
    page: wpPage(id: { eq: $id }) {
      title
      evergage_Enabled_Page {
        evergageEnabledPage
      }
      Wubot_Enabled_Page {
        wubotEnabledPage
      }
      disable_Header_And_Footer {
        disableHeaderAndFooter
      }
      seo {
        canonical
        cornerstone
        focuskw
        metaDesc
        metaKeywords
        metaRobotsNofollow
        metaRobotsNoindex
        opengraphAuthor
        opengraphDescription
        opengraphModifiedTime
        opengraphPublishedTime
        opengraphPublisher
        opengraphSiteName
        opengraphTitle
        opengraphType
        opengraphUrl
        title
        twitterDescription
        twitterTitle
      }
    }
    countryThemeSetting: wpCountryThemeSetting(title: { eq: $countryName }) {
      countryThemeSettings {
        fieldGroupName
        footer {
          copyright
        }
        appBanner {
          description
          downloadButtonText
          fieldGroupName
          smartLink
          title
        }
      }
      languageCountryThemeSetting {
        languageCountryThemeSettings {
          language
          appBanner {
            description
            downloadButtonText
            fieldGroupName
            smartLink
            title
          }
        }
      }
    }
  }
`
